import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Topbar from "../Topbar/Topbar";
import { FaStarOfLife } from "react-icons/fa6";
import { Modal, Box, Button } from "@mui/material";
import { ImCross } from "react-icons/im";
import { FiX, FiUpload } from "react-icons/fi"; // Close & Upload icons
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./AddEnquiry.css";
import { useEffect } from "react";
import { FaUserEdit } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import MessageBox from "../MessageBox/MessageBox";

import { useRef } from "react";
import _ from "lodash";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function View_Enquiry() {
  const permissions = useSelector((state) => state.permissions);
  
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [selectedNames, setSelectedNames] = useState([]);
  const [pageRefId, setpageRefId] = useState("")
  const [isOpen, setIsOpen] = useState(false); 
  const dropdownRef = useRef(null);
  const Id = useSelector((state) => state.id);
  const [searchText, setSearchText] = useState('');
  const [routerMaterial, setRouterMaterial] = useState([]);

  const locate = useLocation();
  const [rows, setRows] = useState([]);
  const [names, setNames] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEditable, setIsEditable] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  // const hideButtons = locate.state?.hideButtons
  const [messageData, setMessageData] = useState([]);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [coordinates, setCoordinates] = useState([0, 0]);
  const hideButtonsRaw = locate.state?.hideButtons;
  const hideButtons = hideButtonsRaw === true || hideButtonsRaw === "true";
  const taskId = locate.state?.taskId;

  console.log(hideButtons,"hide buttons")

  const viewnavigte = locate.state;
  console.log(viewnavigte)

  console.log(taskId)

  const staffName = useSelector((state) => state.staffname);
  console.log(staffName);
  const formatDate = (date) => {
    return dayjs(date).format("DD-MM-YYYY");
  };
  const [ottData, setOttData] = useState([]);

  // to track update mode
  const [originalComplaint, setOriginalComplaint] = useState(null);
  const [enquiryDetails, setenquiryDetails] = useState({});
  const [originalData, setOriginalData] = useState({});
  const [approvePerson, setApprovePerson] = useState(null);  // initially no one selected
  const [approvePersons, setApprovePersons] = useState([]);  // Array of selected persons
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const approveDropdownRef = useRef(null);

  const [searchTerm, setSearchTerm] = useState("");

const filteredNames = staffData
  .filter((staff) =>
    staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
  );

const filteredAccountManagers = staffData.filter((staff) =>
  ["Marketing Executive"].includes(staff.designation)
);



    useEffect(() => {
      axios.get(apiUrl + "/get_fibermetersellingcost").then((res) => {
        const data = res.data;
        const fiberData = Array.isArray(data) && data.length > 0 ? data[0] : null;
  
        setenquiryDetails((prev) => ({
          ...prev,
          enquiryplanDetails: {
            ...prev.enquiryplanDetails,
            enquiryfiberCost: fiberData?.fibermetersellingcost || 0,
          },
        }));
      });
    }, []);

  const listView = () => {
    axios
      .post(apiUrl + "viewlead", {})
      .then((res) => {
        setRows(res.data.message);
      })
      .catch((error) => {
        console.error("Error fetching data", error);
      });
  };

  useEffect(() => {
    listView();
  }, []);

  useEffect(() => {
    if (locate.state?.id) {
      axios
        .post(apiUrl + "get-enquiry", {
          id: locate.state.id, // ✅ send MongoDB _id
        })
        .then((res) => {
          setenquiryDetails(res.data.message);
          setOriginalData(res.data.message);
          setpageRefId(res.data.message._id)
        })
        .catch((err) => console.error("Fetch failed", err));
    }
  }, [locate.state?.id]);


  console.log(pageRefId)


  //  const handleChange = (e) => {
  //   setenquiryDetails({
  //     ...enquiryDetails,
  //     [e.target.name]: e.target.value,
  //   });
  // };


  const handleChange = (e) => {
    const { name, value } = e.target;

    // Check if it's a nested field under enquiryplanDetails
    if (name === "enquiryadvanceAmountPay") {
      setenquiryDetails((prev) => ({
        ...prev,
        enquiryplanDetails: {
          ...prev.enquiryplanDetails,
          enquiryadvanceAmountPay: value,
        },
      }));
    } else {
      // If it's a top-level field
      setenquiryDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };



 const handlePlanChange = (e) => {
    const { name, value } = e.target;

    const convertCurrencyStringToNumber = (str) => {
      const cleaned = str.replace(/[₹,]/g, "");
      return parseFloat(cleaned);
    };

    // Handle OTT pack selection
    if (name === "enquiryottPackDetails") {
      const selectedOtt = ottData.find((ott) => ott.ottDetail === value);
      const ottPrice = selectedOtt
        ? convertCurrencyStringToNumber(selectedOtt.ottPrice)
        : 0;

      setenquiryDetails((prev) => ({
        ...prev,
        enquiryplanDetails: {
          ...prev.enquiryplanDetails,
          enquiryottPackDetails: value,
          enquiryottPrice: [ottPrice],
        },
      }));
      return;
    }

    // Handle router selection
    if (name === "enquiryrouterModel") {
      const selectedRouter = routerMaterial.find(
        (r) => r.materialType === value
      );
      const routerCost = selectedRouter ? selectedRouter.sellingCost : 0;

      setenquiryDetails((prev) => ({
        ...prev,
        enquiryplanDetails: {
          ...prev.enquiryplanDetails,
          enquiryrouterModel: value,
          enquiryrouterCost: routerCost,
          routerSellingCost:routerCost,
        },
      }));
      return;
    }

    // Allow only decimals in 'enquiryothers'
    if (name === "enquiryothers") {
      const decimalRegex = /^\d*\.?\d{0,2}$/;
      if (value === "" || decimalRegex.test(value)) {
        setenquiryDetails((prev) => ({
          ...prev,
          enquiryplanDetails: {
            ...prev.enquiryplanDetails,
            [name]: value,
          },
        }));
      }
      return;
    }

    // Default handling
    setenquiryDetails((prev) => ({
      ...prev,
      enquiryplanDetails: {
        ...prev.enquiryplanDetails,
        [name]: value,
      },
    }));
  };




  const [taskData, setTaskData] = useState({
    taskName: "Enquiry",
    assignDateTime: "",
    taskType: "Once",
    taskPriority: "Low",
    deadline: "",
    time: "",
    assignedTo: [], // Array for multiple selections

    approvePerson: '',
    description: '',
    name: '',
    leadId: '',
    taskStatus: 'Open',
    assignedBy: '',
  });


  useEffect(() => {
    if (staffName) {
      setTaskData((prev) => ({ ...prev, assignedBy: staffName }));
    }
  }, [staffName]);

  console.log(taskData.staffName);

  const [isOpenAssign, setIsOpenAssign] = useState(false);



  const [selectedFile, setSelectedFile] = useState(null);

  const [isOpenAdvancePayment, setIsOpenAdvancePayment] = useState(false);

  // Handle file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const [isOpenplan, setIsOpenplan] = useState(false);
  const [isOpenConverted, setIsOpenConverted] = useState(false);

  const navigate = useNavigate();



  // State initialization

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (isEditMode) {
  //     // ✅ Check if there are any changes
  //     if (_.isEqual(enquiryDetails, originalComplaint)) {
  //       Swal.fire("No Changes", "No changes were made to update.", "info");
  //       return;
  //     }
  //   }

  //   const result = await Swal.fire({
  //     title: isEditMode ? "Update the changes?" : "Are you sure?",
  //     showCancelButton: true,
  //     confirmButtonText: isEditMode ? "Update" : "Submit",
  //   });

  //   const now = new Date();

  //   // Format date and time (optional - customize as needed)
  //   const date = now.toLocaleDateString(); // e.g., "5/23/2025"
  //   const time = now.toLocaleTimeString();

  //   const updatedEnquiryDetails = {
  //     ...enquiryDetails,
  //     updatedBy:
  //     {
  //       staffname: staffName,
  //       _id: Id,
  //       time: time,
  //       date: date
  //     }

  //   };

  //   if (result.isConfirmed) {
  //     try {
  //       if (isEditMode) {
  //         await axios.post(
  //           apiUrl + "update-lead-enquiry",
  //           updatedEnquiryDetails,
  //           { headers: { "Content-Type": "application/json" } }
  //         );
  //         let taskStatus = "";

  //         if (enquiryDetails.leadStatus === "Hold" || enquiryDetails.leadStatus === "No Response") {
  //           taskStatus = "Hold";
  //         } else if (
  //           enquiryDetails.leadStatus === "Not Feasible" ||
  //           enquiryDetails.leadStatus === "Converted" ||
  //           enquiryDetails.leadStatus === "Cancelled"
  //         ) {
  //           taskStatus = "Completed";
  //         }
  //         // e.g., "10:45:32 AM"
  //         await axios.put(apiUrl + "update-task", {
  //           id: taskId,
  //           updateData: {
  //             taskStatus: taskStatus,
  //             taskUpdatedBy: {
  //               staffName: staffName,
  //               _id: Id,
  //               time: time,
  //               date: date,
  //             }

  //           }
  //         }, {
  //           headers: { "Content-Type": "application/json" }

            
  //         });
  //         Swal.fire("Updated!", "Data updated successfully", "success");
  //       }

  //       setIsEditable(false);
  //       setIsEditMode(false);
  //     } catch (error) {
  //       Swal.fire(
  //         "Error",
  //         error.response?.data?.message || "Something went wrong!",
  //         "error"
  //       );
  //     }
  //   }
  // };

const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ Skip update if no changes made
  if (isEditMode && _.isEqual(enquiryDetails, originalComplaint)) {
    Swal.fire("No Changes", "No changes were made to update.", "info");
    return;
  }

  const result = await Swal.fire({
    title: isEditMode ? "Update the changes?" : "Are you sure?",
    showCancelButton: true,
    confirmButtonText: isEditMode ? "Update" : "Submit",
  });

  const now = new Date();
  const date = now.toLocaleDateString();
  const time = now.toLocaleTimeString();

  const updatedEnquiryDetails = {
    ...enquiryDetails,
    updatedBy: {
      staffname: staffName,
      _id: Id,
      time,
      date,
    },
  };

  if (result.isConfirmed) {
    if (isEditMode) {
      try {
        // 🔵 Update enquiry data
        const enquiryUpdateResponse = await axios.post(
          apiUrl + "update-lead-enquiry",
          updatedEnquiryDetails,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        console.log("Updated Enquiry:", enquiryUpdateResponse.data);

        // --- Determine task status ---
        let taskStatus = "";
        if (
          enquiryDetails.leadStatus === "Hold" ||
          enquiryDetails.leadStatus === "No Response"||
                    enquiryDetails.leadStatus === "Not Feasible" ||
                              enquiryDetails.leadStatus === "Converted" ||

                                        enquiryDetails.leadStatus === "Cancelled"


        ) {
          taskStatus = "Completed";
        } 
        
        // else if (
        //   ["Not Feasible", "Converted", "Cancelled"].includes(enquiryDetails.leadStatus)
        // ) {
        //   taskStatus = "Completed";
        // }

        // 🔄 Update task if required
        if (hideButtons === true) {
          await axios.put(apiUrl + "update-task", {
            id: taskId,
            updateData: {
              taskStatus,
              taskUpdatedBy: {
                staffName,
                _id: Id,
                time,
                date,
              },
            },
          });

          // ✅ If task is completed, call /work-detail
          if (taskStatus === "Completed") {
            const workDetailPayload = {
              type: "enquiry", // You can change this to "complaint" or "installation" as needed
              pageRefId: enquiryDetails._id,
              staffId: Id,
              staffName: staffName,
              actionStatus: "complete",
              // Optional fields:
              // bikeType: ...,
              // cableUsed: ...,
              // location: { latitude: ..., longitude: ... },
            };

            try {
              await axios.post(apiUrl + "work-detail", workDetailPayload, {
                headers: { "Content-Type": "application/json" },
              });
              console.log("Work detail logged successfully.");
            } catch (err) {
              console.error("Work detail logging failed:", err.response?.data || err.message);
            }
          }
        }

        // 🎨 Determine color code for message log
        let colorCode = "#cccccc";
        switch (enquiryDetails.leadStatus) {
          case "Open":
            colorCode = "#fbdc6e";
            break;
          case "No Response":
            colorCode = "#ffa5ee";
            break;
          case "Converted":
            colorCode = "#2c693a";
            break;
          case "Hold":
            colorCode = "#ffa770";
            break;
          case "Cancelled":
            colorCode = "#f07c7c";
            break;
          case "Not Feasible":
            colorCode = "#2e5caf";
            break;
        }

        // 📨 Add message (with optional image)
        const formData = new FormData();
        formData.append("pageRefId", enquiryDetails._id);
        formData.append("page", "Enquiry");
        formData.append(
          "description",
          enquiryDetails.enquiryleadStatus?.enquirynotes || ""
        );
        if (selectedFile) formData.append("image", selectedFile);
        formData.append("updatesHistory[staff][name]", staffName);
        formData.append("updatesHistory[staff][id]", Id);
        formData.append("updatesHistory[status]", enquiryDetails.leadStatus);
        formData.append("colorCode", colorCode);

        try {
          await axios.post(apiUrl + "add-message", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          const res = await axios.get(`${apiUrl}messages/${pageRefId}`);
          setMessageData(res.data.data);
          setShowMessageBox(true);
        } catch (err) {
          console.warn("Message save failed, skipped showing error.");
        }

        Swal.fire("Updated!", "Data updated successfully", "success");
        setIsEditable(false);
        setIsEditMode(false);
      } catch (error) {
        const apiMessage =
          error.response?.data?.message ||
          error.message ||
          "Failed to update enquiry.";

        Swal.fire("Update Failed", apiMessage, "error");
        console.error("update-lead-enquiry error:", error.response?.data || error);
      }
    }
  }
};


 const formatLocation = (location) => {
    if (!location) return "";
    
    if (typeof location === "string") {
      return location;
    }
    
    if (location.latitude && location.longitude) {
      return `${location.latitude}, ${location.longitude}`;
    }
    
    if (location.lat && location.lng) {
      return `${location.lat}, ${location.lng}`;
    }
    
    if (Array.isArray(location.coordinates)) {
      return `${location.coordinates[1]}, ${location.coordinates[0]}`; // Note: coordinates are typically [longitude, latitude]
    }
    
    return "";
  };





  const handleAmountChange = (e) => {
    const { name, value } = e.target;
    setenquiryDetails((prevState) => ({
      ...prevState,
      enquiryplanDetails: {
        ...prevState.enquiryplanDetails,
        enquiryadvanceAmount: {
          ...prevState.enquiryplanDetails.enquiryadvanceAmount,
          [name]: value,
        },
      },
    }));
  };

  const handleLeadChange = (e) => {
    const { name, value } = e.target;
    setenquiryDetails((prevState) => ({
      ...prevState,
      enquiryleadStatus: {
        ...prevState.enquiryleadStatus,
        [name]: value,
      },
    }));
  };

  //form validation



  //Email
  const [errorEmail, setErrorEmail] = useState("");
  const handleEmailBlur = () => {
    if (enquiryDetails.enquiryemailId.trim() !== "") {
      if (!validateEmail(enquiryDetails.enquiryemailId)) {
        setErrorEmail(
          "Please enter a valid email address (e.g., example@domain.com)."
        );
      } else {
        setErrorEmail("");
      }
    } else {
      setErrorEmail(""); // Clear the error if the field is empty
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|edu)$/i;
    return emailRegex.test(email);
  };



  const formatDateTimeLocal = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};



useEffect(() => {
  if (taskData.assignDateTime) {
    const assignDate = new Date(taskData.assignDateTime);
    const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000); // +4 hours
    const formattedDeadline = formatDateTimeLocal(deadlineDate);

    setTaskData(prev => ({
      ...prev,
      deadline: formattedDeadline
    }));
  }
}, [taskData.assignDateTime]);





const handleInputChange = (field, value) => {
  if (field === 'assignDateTime') {
    const assignDate = new Date(value);
    const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000);
    const formattedDeadline = deadlineDate.toISOString().slice(0, 16);

    setTaskData(prev => ({
      ...prev,
      assignDateTime: value,
      deadline: formattedDeadline // auto update
    }));
  } else {
    setTaskData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};



  useEffect(() => {
    axios.get(apiUrl + "get-staff-names")
      .then((res) => {
        if (res.data.message) {
          setNames(res.data.message);  // names = array of objects like { _id, staffName }
        }
      })
      .catch((err) => {
        console.log("Error fetching staff names:", err);
      });

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Fetch staff whole data for dropdown
        useEffect(() => {
          axios
            .post(
              apiUrl + "viewstaff",
      
              {}
            )
            .then((res) => {
              setStaffData(res.data.message);
      
              console.log(res.data.message);
             
            });
        }, [apiUrl]);
        const handleApproveCheckboxChange = (staff) => {
          setApprovePersons((prev) => {
            const isSelected = prev.some((item) => item._id === staff._id);
            if (isSelected) {
              return prev.filter((item) => item._id !== staff._id); // remove if unchecked
            } else {
              return [...prev, staff]; // add if checked
            }
          });
        };
        
        
        useEffect(() => {
          const defaultApproved = staffData.filter((staff) => {
            return (
              staff.designation &&
              staff.designation.toLowerCase().trim() === "marketing admin"
            );
          });
        
          setApprovePersons(defaultApproved);
        }, [staffData]);

  // Toggle dropdown open/close
  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  // Checkbox change handler expects a staffName string
  const handleCheckboxChange = (staff) => {
    setSelectedNames(prev => {
      const exists = prev.find(item => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter(item => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };

  const displayText = selectedNames.length > 0
    ? selectedNames.map(item => item.staffName).join(', ')
    : 'Select names';



  const toggleApproveDropdown = () => {
    setIsApproveOpen(prev => !prev);
  };


  // const handleApproveCheckboxChange = (staff) => {
  //   setApprovePersons(prev => {
  //     const exists = prev.find(item => item._id === staff._id);
  //     if (exists) {
  //       // Remove staff
  //       return prev.filter(item => item._id !== staff._id);
  //     } else {
  //       // Add staff
  //       return [...prev, staff];
  //     }
  //   });
  // };
  const approvePersonText = approvePersons.length > 0
    ? approvePersons.map(item => item.staffName).join(', ')
    : 'Select Approve Persons';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (approveDropdownRef.current && !approveDropdownRef.current.contains(event.target)) {
        setIsApproveOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const handleSubmitAssignTask = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure you want to create this task?",
      showCancelButton: true,
      confirmButtonText: "Submit",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const now = new Date();
          const day = String(now.getDate()).padStart(2, "0");
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const year = now.getFullYear();
          const updatedDate = `${day}-${month}-${year}`;

          let hours = now.getHours();
          const minutes = String(now.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          const updatedTime = `${hours}:${minutes} ${ampm}`;

          const datas = {
            ...taskData,
            assignedBy: {
              staffName: staffName,
              id: Id
            },
            updatedDate,
            updatedTime,
            assignedTo: selectedNames,
            approvePerson: approvePersons,
            collectionId: enquiryDetails._id
          };

          // Required fields to check
          const requiredFields = [
            "taskName",
            "assignDateTime",
            // "taskPriority",
            // "taskType",
            "deadline",
            "assignedTo",
            "approvePerson",
            "description",
          ];

          // Check for empty fields
          const emptyFields = requiredFields.filter(
            (field) => !datas[field] || (Array.isArray(datas[field]) && datas[field].length === 0)
          );

          if (emptyFields.length > 0) {
            Swal.fire({
              icon: "warning",
              title: "Incomplete Data",
              text: `Please fill all the fields:`,
            });
            return;
          }

          const response = await axios.post(
            apiUrl + "add-assign-task",
            datas,
            { headers: { "Content-Type": "application/json" } }
          );

          Swal.fire({
            title: "Task Created Successfully!",
            icon: "success",
          }).then(() => {
            navigate("/task");
          });
        } catch (error) {
          console.log("Error submitting data:", error.response?.data || error.message);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response?.data?.message || "Something went wrong!",
          });
        }
      }
    });
  };



  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;

    setTaskData(prev => ({
      ...prev,
      assignDateTime: formattedDate,
    }));
  }, []);


  useEffect(() => {
    axios.post(apiUrl + "viewott", {}).then((res) => {
      const add_installation = res.data.message || [];
      console.log("Fetched data:", add_installation); // ✅ Check this output

      setOttData(add_installation);


    });
  }, []);

  useEffect(() => {
    axios.get(apiUrl + "/router-selling/all", {}).then((res) => {
      const add_installation = res.data || [];
      console.log("Fetched data:", add_installation); // ✅ Check this output

      setRouterMaterial(add_installation);
    });
  }, []);
   // Initialize coordinates when recoveryData changes
    useEffect(() => {
      if (enquiryDetails?.location) {
        if (Array.isArray(enquiryDetails.location.coordinates)) {
          setCoordinates(enquiryDetails.location.coordinates);
        } else if (enquiryDetails.location.latitude && enquiryDetails.location.longitude) {
          setCoordinates([enquiryDetails.location.longitude, enquiryDetails.location.latitude]);
        } else if (enquiryDetails.location.lng && enquiryDetails.location.lat) {
          setCoordinates([enquiryDetails.location.lng, enquiryDetails.location.lat]);
        }
      }
    }, [enquiryDetails]);


  // useEffect(() => {
  //   const fetchMessages = async () => {
  //     try {
  //       const response = await axios.get(`${apiUrl}messages/${pageRefId}`);

  //       if (response.status === 200 && response.data) {
  //         setMessageData(response.data);
  //         console.log(response.data)
  //       } else {
  //         console.error("Unexpected response structure:", response);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching messages:", error);
  //     }
  //   };

  //   if (pageRefId) {
  //     fetchMessages();
  //   }
  // }, [apiUrl, pageRefId]);

  useEffect(() => {
  const fetchMessages = async () => {
    try {
      const response = await axios.get(`${apiUrl}messages/${pageRefId}`);

      if (response.status === 200 && Array.isArray(response.data.data)) {
        setMessageData(response.data.data); // ✅ Only the array!
      } else {
        console.error("Unexpected response structure:", response);
        setMessageData([]); // fallback to empty array
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
      setMessageData([]); // fallback to empty array
    }
  }; 

  fetchMessages();
}, [apiUrl, pageRefId]);

  console.log(messageData)

  console.log(routerMaterial)

  console.log(hideButtons)

  const getFutureDateTime = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 1); // add 1 minute to current time
  return now.toISOString().slice(0, 16); // returns 'YYYY-MM-DDTHH:MM'
};

  return (
    <>
      <Topbar />
      <Container className="mt-1    ">
        <form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <h3>Enquiry</h3>
            </Col>


            {!isEditMode && (
              <Col className="text-end me-5">
   {(
  (hideButtons
    ? permissions?.Enquiry?.["Enquiry Updates"]?.Write
    : permissions?.Enquiry?.["Add Enquiry"]?.Write
  ) && (
    <button
      className="black-btn me-3"
      type="button"
      onClick={() => {
        setOriginalComplaint(JSON.parse(JSON.stringify(enquiryDetails)));
        setIsEditable(true);
        setIsEditMode(true);
      }}
    >
      <MdEdit size={18} /> {hideButtons ? "Update" : "Edit"}
    </button>
  )
)}


                {hideButtons ||
                  !["Not Feasible", "Cancelled", "Converted"].includes(enquiryDetails.leadStatus) && (
                    <button
                      className="blue-btn me-3"
                      type="button"
                      onClick={() => {
                        setTaskData({
                          ...taskData,
                          name: enquiryDetails.enquirycustomerName || "",
                          leadId: enquiryDetails.leadId || "",
                        });
                        setIsOpenAssign(true);
                      }}
                    >
                      <FaUserEdit size={18} /> Assign
                    </button>
                  )}

                {isOpenAssign && (
                  <div className="overlay3">
                    <div className="modal3">
                      <Container>
                        <div className=" text-end mx-2">
                          <button
                            type="button"
                            className="black-btn mx-3"
                            onClick={() => setIsOpenAssign(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className=" blue-btn mx-3"
                            onClick={handleSubmitAssignTask}
                          >
                            Submit
                          </button>
                        </div>

                        <Row className="mt-4">
                          <Col xs={12} md={6}>
                            <Row>
                              <Col xs={12} md={6} className="text-start">
                                <lable>Task Name</lable>
                                <br />
                                <input
                                  type="text"
                                  className="form-input"
                                  readOnly
                                  value={taskData.taskName}
                                />
                              </Col>
                              <Col xs={12} md={6} className="text-start">
                                <lable>Assign Date/Time</lable>
                                <br />
                                <input
                                  type="datetime-local"
                                  value={taskData.assignDateTime || ""} // fallback to empty string
                                  required
                                    min={getFutureDateTime()} // optional: restrict past values

                                  className="form-input"
                                  onChange={(e) => handleInputChange("assignDateTime", e.target.value)}
                                />

                              </Col>
                            </Row>
                          </Col>
                          <Col>
                            <Row>
                              {/* <Col xs={12} md={6} className="text-start">
                                <lable>Task Type</lable>

                                <br />
                                <select
                                  onChange={(e) =>
                                    handleInputChange(
                                      "taskType",
                                      e.target.value
                                    )
                                  }
                                  class="dropbtn form-input-select overlay2"
                                >

                                  <option value="Once">Once</option>
                                  <option value="Daily">Daily</option>
                                  <option value="weekly">Weekly</option>
                                  <option value="Monthy">Monthly</option>
                                  <option value="Custom">Custom</option>
                                </select>
                              </Col> */}

                              <Col xs={12} md={6} className="text-start">
                                <label>Task Priority</label>
                                <br />
                                <select
                                  value={taskData.taskPriority}
                                  onChange={(e) => handleInputChange("taskPriority", e.target.value)}
                                  className="dropbtn form-input-select overlay2"
                                >
                                  <option value="Low">Low</option>
                                  <option value="High">High</option>
                                  <option value="Immediate">Immediate</option>
                                </select>
                              </Col>

                                  <Col xs={12} md={6} className="text-start">
                                <lable>Deadline Date/Time</lable>
                                <br />
                               <input
  type="datetime-local"
  value={taskData.deadline || ""}
  min={getFutureDateTime()} // optional: restrict past values
  onChange={(e) =>
    handleInputChange("deadline", e.target.value)
  }
  className="form-input overlay2"
/>

                              </Col>
                            


                            </Row>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12} md={6}>
                            <Row>
                          
                              {/* <Col xs={12} md={6} className="text-start">
                                <lable> Deadline Time</lable>
                                <br />
                                <input
                                  type="time"
                                  onChange={(e) =>
                                    handleInputChange("time", e.target.value)
                                  }
                                  className="form-input overlay2"
                                  placeholder=""
                                />
                              </Col> */}


                                <Col xs={12} md={6} className="text-start">
                                <lable>Lead ID</lable>
                                <br />
                                <input
                                  type="text"
                                  value={taskData.leadId}
                                  className="form-input overlay2"
                                  readOnly
                                />
                              </Col>
                              <Col xs={12} md={6} className="text-start">
                                <lable>Name </lable>
                                <br />
                                <input
                                  type="text"
                                  onChange={(e) =>
                                    handleInputChange("name", e.target.value)
                                  }
                                  style={{ textTransform: "capitalize" }}
                                  className="form-input "
                                  placeholder="Enter Notes "
                                  readOnly
                                  value={taskData.name}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col>
                            <Row>
                                                          <Col xs={12} md={6} className="text-start">
                              <label>Task Assign To</label>
                              <br />
                              <div ref={dropdownRef} style={{ position: 'relative', width: '85%' }}>
                                <div
                                  onClick={toggleDropdown}
                                  style={{
                                    padding: '10px',
                                    border: '2px solid #a7a7a7',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: "10px"
                                  }}
                                >
                                  <span style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}>
                                    {displayText}
                                  </span>
                                  <span>{isOpen ? '▲' : '▼'}</span>
                                </div>
                            
                                {isOpen && (
                                  <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    marginTop: '5px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                    zIndex: 1000,
                                    maxHeight: '250px',
                                    overflowY: 'auto'
                                  }}>
                            
                                    {/* 🔍 Search Input */}
                                    <input
                                      type="text"
                                      placeholder="Search staff..."
                                      value={searchText}
                                      onChange={(e) => setSearchText(e.target.value)}
                                      style={{
                                        width: '95%',
                                        margin: '10px auto',
                                        display: 'block',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc'
                                      }}
                                    />
                            
                                    {/* Filtered Staff List */}
                                    {staffData
                                      .filter(staff =>
                                        staff.staffName.toLowerCase().includes(searchText.toLowerCase())
                                      ).length === 0 ? (
                                      <div style={{ padding: '10px', color: '#888', textAlign: 'center' }}>
                                        No Staffs found
                                      </div>
                                    ) : (
                                      staffData
                                        .filter(staff =>
                                          staff.staffName.toLowerCase().includes(searchText.toLowerCase())
                                        )
                                        .map((staff) => (
                                          <label
                                            key={staff._id}
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              padding: '10px',
                                              cursor: 'pointer',
                                              borderBottom: '1px solid #eee',
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={selectedNames.some(item => item._id === staff._id)}
                                              onChange={() => handleCheckboxChange(staff)}
                                              style={{ marginRight: '10px' }}
                                            />
                                            {staff.staffName} {staff.designation ? `(${staff.designation})` : ""}
                                          </label>
                                        ))
                                    )}
                                  </div>
                                )}
                              </div>
                            </Col>

                                                        <Col xs={12} md={6} className="text-start">
                              <label>Approve Person</label>
                              <br />
                              <div ref={approveDropdownRef} style={{ position: 'relative', width: '85%', marginTop: '15px' }}>
                                <div
                                  onClick={toggleApproveDropdown}
                                  style={{
                                    padding: '10px',
                                    border: '2px solid #a7a7a7',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: '-5px'
                                  }}
                                >
                                  <span style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }}>
                                    {approvePersonText}
                                  </span>
                                  <span>{isApproveOpen ? '▲' : '▼'}</span>
                                </div>
                            
                                {isApproveOpen && (
                                  <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    marginTop: '5px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                    zIndex: 1000,
                                    maxHeight: '250px',
                                    overflowY: 'auto'
                                  }}>
                                    {/* 🔍 Search Input */}
                                    <input
                                      type="text"
                                      placeholder="Search staff..."
                                      value={searchTerm}
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '8px 10px',
                                        borderBottom: '1px solid #ccc',
                                        boxSizing: 'border-box',
                                        outline: 'none',
                                        border: 'none'
                                      }}
                                    />
                            
                                    {/* 🧑‍💼 Filtered Staff List */}
                                    {filteredNames.length === 0 ? (
                                      <div style={{ padding: '10px', color: '#888', textAlign: 'center' }}>
                                        No staff found
                                      </div>
                                    ) : (
                                      filteredNames.map((staff) => (
                                        <label
                                          key={staff._id}
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '10px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            required
                                            
                                            checked={approvePersons.some((item) => item._id === staff._id)}
                                            onChange={() => handleApproveCheckboxChange(staff)}
                                            style={{ marginRight: '10px' }}
                                          />
                                          {staff.staffName || "(No Name)"}
                                        </label>
                                      ))
                                    )}
                                  </div>
                                )}
                              </div>
                            </Col>
                            </Row>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12} md={6} className="text-start">
                            <lable>Description</lable>
                            <br />
                            <textarea
                              type="text"
                              onChange={(e) =>
                                handleInputChange("description", e.target.value)
                              }
                              style={{
                                textTransform: "capitalize",
                                resize: "none",
                              }}
                              className="form-input inputfield-assign "
                              placeholder="Enter Notes "
                            />
                          </Col>
                          <Col>
                            <Row>
                              
                              
                              <Col xs={12} md={6} className="text-start">
                                <lable>Task Status </lable>
                                <br />
                                <input
                                  type="text"
                                  onChange={(e) =>
                                    handleInputChange(
                                      "taskStatus",
                                      e.target.value
                                    )
                                  }
                                  // style={{ textTransform: "capitalize" }}
                                   style={{
                        backgroundColor: "#fbdc6e",
                        color: "rgb(94, 94, 14)",
                        textTransform: "capitalize",
                      }}
                                  className="form-input "
                                  value={taskData.taskStatus}
                                  readOnly
                                />
                              </Col>
                            </Row>
                            <Row>
                              
                            </Row>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </div>
                )}
              </Col>
            )}

            {isEditMode && isEditable && (
              <>
                <button className="blue-btn" type="submit">
                  Submit
                </button>
                <button
                  className="black-btn ms-2 me-5"
                  type="button"
                  onClick={() => {
                    setenquiryDetails(
                      JSON.parse(JSON.stringify(originalComplaint))
                    );
                    setIsEditable(false);
                    setIsEditMode(false);
                  }}
                >
                  Cancel
                </button>
              </>
            )}

          </Row>

          <div className="border-container1">
            <h6 className="form-head  m-0 text-white  ">Order Details</h6>
          </div>

          <div className="border-container ">
            <Row
              className="text-start lead-id-row  mb-4 mt-4 ms-4 "
              disabled={!isEditable}
            // Disable cancel button when not in edit mode
            >
              <p className="ps-5 paragraph-lead-id">
                Lead ID -{" "}
                <span className="text-primary ">{enquiryDetails.leadId} </span>{" "}
                <span className="lead-start-date">
                  {" "}
                  Lead Started Date -{" "}
                  <span className="text-primary">
                    {formatDate(enquiryDetails.createdDate)}
                  </span>
                </span>{" "}
              </p>
            </Row>
            <Row className="ms-3">
              <Col sm={12} md={6} className="text-start ">
                <lable>Customer Name</lable>
                <br />
                <input
                  type="text"
                  name="enquirycustomerName"
                  placeholder="Enter Customer Name"
                  className="form-input"
                  style={{ textTransform: "capitalize" }}
                  value={enquiryDetails.enquirycustomerName}
                  onChange={handleChange}
                  disabled={!isEditMode}
                />
              </Col>

              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>
                      Contact Number
                      <sup>
                        <FaStarOfLife size={7} />
                      </sup>
                    </lable>
                    <br />
                    <input
                      type="tel"
                      disabled={!isEditMode}
                      name="enquirycontactNum"
                      value={enquiryDetails.enquirycontactNum}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      placeholder="Enter Phone Number"
                      className="form-input"
                      maxLength={10}
                      required
                    />
                  </Col>

                  <Col xs={12} md={6} className="text-start">
                    <lable>Alternate Number </lable>
                    <br />
                    <input
                      type="tel"
                      disabled={!isEditMode}
                      name="enquiryalternateNum"
                      value={enquiryDetails.enquiryalternateNum}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      maxLength={10}
                      className="form-input"
                      placeholder="Enter Phone Number"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="ms-3">
              <Col xs={12} md={6} className="text-start">
                <lable> Address</lable>
                <br />
                <textarea
                  disabled={!isEditMode}
                  type="text"
                  name="enquiryaddress"
                  value={enquiryDetails.enquiryaddress}
                  onChange={handleChange}
                  style={{ textTransform: "capitalize", resize: "none" }}
                  className=" box address-enquiry"
                  placeholder="Enter  Address"
                />
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Location</lable>
                    <br />
                    <input
                      name="location"
                       value={formatLocation(enquiryDetails?.location)}
                      onChange={handleChange}
                      disabled={!isEditMode}
                      style={{ textTransform: "capitalize" }}
                      className="form-input"
                      type="text"
                      placeholder="Enter Location"
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Lead Source</lable>
                    <br />

                    <select
                      disabled={!isEditMode}
                      class="dropbtn form-input-select"
                      name="enquiryleadSource"
                      value={enquiryDetails.enquiryleadSource}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>

                      {rows.map((data, i) => {
                        return <option>{data.leadSource}</option>;
                      })}
                    </select>
                  </Col>
                </Row>
                <Row>

                  <Col md={6} sm={12} className="text-start">
                  <label>Account Manager</label>

                                   <select
  disabled={!isEditMode}
  value={enquiryDetails.enquiryaccountManager?._id || ""}
  onChange={(e) => {
    const selected = names.find((staff) => staff._id === e.target.value);
    if (selected) {
      setenquiryDetails((prev) => ({
        ...prev,
        enquiryaccountManager: {
          _id: selected._id,
          staffName: selected.staffName?.trim() || "",
        },
      }));
    } else {
      setenquiryDetails((prev) => ({
        ...prev,
        enquiryaccountManager: {
          _id: "",
          staffName: "",
        },
      }));
    }
  }}
  name="enquiryaccountManager"
  className="dropbtn form-input-select"
>
  <option value="">Select</option>
  {filteredAccountManagers.map((staff) => (
    <option key={staff._id} value={staff._id}>
      {staff.staffName?.trim()}
    </option>
  ))}
</select>
                  </Col>
   

                  

                  <Col xs={12} md={6} className="text-start">
                    <label></label>
                    <input
                      disabled={!isEditMode}
                      type="button"
                      onChange={handleChange}
                      value="Plan details"
                      onClick={() => setIsOpenplan(true)}
                      className="form-input converted-form plandetails-form "
                    />

                    {isOpenplan && (
                      <div className="overlay1">
                        <div className="modal1">
                          <Container>
                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Speed</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      className="form-input overlay2"
                                      placeholder="Enter Plan Speed"
                                      name="enquiryplanSpeed"
                                      value={
                                        enquiryDetails.enquiryplanDetails
                                          .enquiryplanSpeed
                                      }
                                      onChange={handlePlanChange}
                                      pattern="^\d*\.?\d{0,2}$"
                                    />
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Month</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="enquiryplanMonth"
                                      value={
                                        enquiryDetails.enquiryplanDetails
                                          .enquiryplanMonth
                                      }
                                      onChange={handlePlanChange}
                                      className="form-input overlay2"
                                      placeholder="Enter Plan Month"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Plan Amount</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="enquiryplanAmount"
                                      value={
                                        enquiryDetails.enquiryplanDetails
                                          .enquiryplanAmount
                                      }
                                      onChange={handlePlanChange}
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Static Ip Cost </lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="enquirystaticIpCost"
                                      value={
                                        enquiryDetails.enquiryplanDetails
                                          .enquirystaticIpCost
                                      }
                                      onChange={handlePlanChange}
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Fiber Cable Meter</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="enquiryfiberCableMeter"
                                      value={
                                        enquiryDetails.enquiryplanDetails
                                          .enquiryfiberCableMeter
                                      }
                                      onChange={handlePlanChange}
                                      className="form-input overlay2"
                                      placeholder="Enter Meter"
                                    />
                                  </Col>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Installation Cost</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="enquiryinstalationCost"
                                      value={
                                        enquiryDetails.enquiryplanDetails
                                          .enquiryinstalationCost
                                      }
                                      onChange={handlePlanChange}
                                      className="form-input overlay2"
                                      placeholder="Enter installation Cost"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                             <Row>
                                                               <Col xs={12} md={6} className="text-start">
                                                                 <label>Router Model</label>
                                                                 <br />
                                                                 <select
                                                                   value={
                                                                     enquiryDetails?.enquiryplanDetails
                                                                       ?.enquiryrouterModel || ""
                                                                   }
                                                                   onChange={handlePlanChange}
                                                                   name="enquiryrouterModel"
                                                                   className="dropbtn form-input-select overlay2" // ✅ fixed `className`
                                                                 >
                                                                   <option value="">Select</option>
                             
                                                                   {routerMaterial?.map((item) => (
                                                                     <option
                                                                       key={item._id}
                                                                       value={item.materialType}
                                                                     >
                                                                       {item.materialType}
                                                                     </option>
                                                                   ))}
                                                                 </select>
                                                               </Col>
                             
                                                               <Col xs={12} md={6} className="text-start">
                                                                 <lable>Router Cost </lable>
                                                                 <br />
                                                                 <input
                                                                   type="tel"
                                                                   value={
                                                                     enquiryDetails?.enquiryplanDetails
                                                                       ?.enquiryrouterCost
                                                                   }
                                                                   onChange={handlePlanChange}
                                                                   name="enquiryrouterCost"
                                                                   className="form-input overlay2"
                                                                   placeholder="Enter installation Cost"
                                                                 />
                                                               </Col>
                                                             </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col xs={12} md={6}>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <label>OTT Pack Details</label>
                                    <br />
                                    <select
                                      value={enquiryDetails.enquiryplanDetails.enquiryottPackDetails}
                                      onChange={handlePlanChange}
                                      name="enquiryottPackDetails"
                                      className="dropbtn form-input-select overlay2"
                                    >
                                      <option value="">Select</option>

                                      {ottData.map((ott) => (
                                        <option key={ott._id} value={ott.ottDetail}>
                                          {ott.ottDetail}
                                        </option>
                                      ))}
                                    </select>
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Others</lable>
                                    <br />
                                    <input
                                      type="text"
                                      name="enquiryothers"
                                      value={
                                        enquiryDetails.enquiryplanDetails
                                          .enquiryothers
                                      }
                                      onChange={handlePlanChange}
                                      style={{ textTransform: "capitalize" }}
                                      className="form-input overlay2"
                                      placeholder="Enter "
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                                <Row>
                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Others Cost</lable>
                                    <br />
                                    <input
                                      type="tel"
                                      name="enquiryothersCost"
                                      value={
                                        enquiryDetails.enquiryplanDetails
                                          .enquiryothersCost
                                      }
                                      onChange={handlePlanChange}
                                      placeholder="Rs"
                                      className="form-input overlay2"
                                    />
                                  </Col>

                                  <Col xs={12} md={6} className="text-start">
                                    <lable>Advance Amount </lable>
                                    <br />
                                    <select
                                      className="form-input-select"
                                      name="enquiryadvanceAmountPay"
                                      value={enquiryDetails.enquiryplanDetails.enquiryadvanceAmountPay || ""}
                                      onChange={(e) => {
                                        handleChange(e);
                                        if (e.target.value === "Pay") {
                                          setIsOpenAdvancePayment(true);
                                        }
                                      }}
                                    >
                                      <option value="">Select Type</option>
                                      <option value="Unpay">Unpay</option>
                                      <option value="Pay">Pay</option>
                                    </select>


                                    {isOpenAdvancePayment && (
                                      <div className="overlay-advance-payment">
                                        <div className="modal-advance-payment">
                                          <Container>
                                            <Row>
                                              <Col>
                                                {" "}
                                                <h6>Advance Pay</h6>
                                              </Col>
                                              <Col className="text-end">
                                                <span
                                                  style={{
                                                    fontSize: "23px",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    setIsOpenAdvancePayment(
                                                      false
                                                    )
                                                  }
                                                >
                                                  <strong>&times;</strong>
                                                </span>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col>
                                                <div>
                                                  <label>Current Date</label>
                                                  <br />
                                                  <input
                                                    className="form-input"
                                                    type="date"
                                                    name="enquirycurrentDate"
                                                    value={
                                                      enquiryDetails
                                                        .enquiryplanDetails
                                                        .enquiryadvanceAmount
                                                        .enquirycurrentDate
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                  />
                                                </div>
                                              </Col>
                                              <Col>
                                                <div>
                                                  <label>Payment Type</label>
                                                  <br />
                                                  <select
                                                    className="form-input-select"
                                                    value={
                                                      enquiryDetails
                                                        .enquiryplanDetails
                                                        .enquiryadvanceAmount
                                                        .enquirypaymentType
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                    name="enquirypaymentType"
                                                  >

                                                    <option value="">
                                                      Select Type
                                                    </option>
                                                    <option value="Private">
                                                      Private
                                                    </option>
                                                    <option value="Technology">
                                                      Technology
                                                    </option>
                                                    <option value="Cash">
                                                      Cash
                                                    </option>
                                                    <option value="Helpdesk">
                                                      Helpdesk
                                                    </option>
                                                    <option value="Others">
                                                      Others
                                                    </option>

                                                  </select>
                                                </div>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col>
                                                <div>
                                                  <label>Amount</label>
                                                  <br />
                                                  <input
                                                    className="form-input"
                                                    placeholder="Rs"
                                                    name="enquiryamount"

                                                    value={
                                                      enquiryDetails
                                                        .enquiryplanDetails
                                                        .enquiryadvanceAmount
                                                        .enquiryamount ||
                                                      ""
                                                    }
                                                    onChange={
                                                      handleAmountChange
                                                    }

                                                  />
                                                </div>
                                              </Col>
                                              <Col>
                                                <div>
                                                  <label>
                                                    Reference Number
                                                  </label>
                                                  <br />
                                                  <input
                                                    className="form-input"
                                                    placeholder="Enter Reference Number"
                                                    onChange={
                                                      handleAmountChange
                                                    }
                                                    value={
                                                      enquiryDetails
                                                        .enquiryplanDetails
                                                        .enquiryadvanceAmount
                                                        .enquiryreferenceNumber
                                                    }
                                                    name="enquiryreferenceNumber"
                                                  />
                                                </div>
                                              </Col>
                                            </Row>

                                            <Row className="text-end mt-5">
                                              <Col className="text-start">
                                                <button
                                                  className="black-btn "
                                                  onClick={() =>
                                                    setIsOpenAdvancePayment(
                                                      false
                                                    )
                                                  }
                                                >
                                                  Cancel
                                                </button>
                                              </Col>
                                              <Col className="text-end">
                                                <button
                                                  className="blue-btn ms-5"
                                                  onClick={() =>
                                                    setIsOpenAdvancePayment(
                                                      false
                                                    )
                                                  }
                                                >
                                                  Submit
                                                </button>
                                              </Col>
                                            </Row>
                                          </Container>
                                        </div>
                                      </div>
                                    )}

                                    {/* </select> */}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <div className="button-group1">
                              <button
                                type="button"
                                className="black-btn"
                                onClick={() => setIsOpenplan(false)}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="ok-btn1"
                                onClick={() => setIsOpenplan(false)}
                              >
                                OK
                              </button>
                            </div>
                          </Container>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="ms-3 ">
              <Col xs={12} md={6} className="text-start update-enquiry-email-row">
                <lable>Mail ID</lable>
                <br />
                <input
                  value={enquiryDetails.enquiryemailId}
                  onChange={handleChange}
                  name="enquiryemailId"
                  disabled={!isEditMode}
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                  type="email"
                  placeholder="Enter Email ID"
                  className="form-input "
                  onBlur={handleEmailBlur}
                />{" "}
                {errorEmail && <p style={{ color: "red" }}>{errorEmail}</p>}
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <lable>Next Follow Up Date</lable>
                    <br />
                    <input
                      readOnly
                      min={new Date().toISOString().split("T")[0]} // only allows today or future

                      // value={enquiryDetails.enquirynextFollowUpDate}
                      onChange={handleChange}
                      value={
                        enquiryDetails?.enquiryleadStatus?.enquiryLeadStatusnextFollowUpDate
                      }                      // name="enquirynextFollowUpDate"
                      className="field form-input"
                      disabled={!isEditMode}
                      type="date"
                    />
                  </Col>
                  <Col xs={12} md={6} className="text-start update-enquiry-email-row">
                    <lable>Lead Status</lable>
                    <br />
                    {/* <input
                      style={{
                        backgroundColor: "#fbdc6e",
                        color: "rgb(94, 94, 14)",
                      }}
                      type="button"
                      onChange={handleChange}
                      name="enquiryLeadStatus"
                      disabled={!isEditMode}
                      onClick={() => setIsOpenConverted(true)}
                      className="form-input converted-form"
                      value={enquiryDetails.leadStatus || ""}
                    /> */}


                    {/* {hideButtons ? (
                      // 👉 Shown when hideButtons === true

                      <select
                        className={`lead-status-select dropbtn form-input-select lead-${enquiryDetails.leadStatus?.replace(/\s/g, '-').toLowerCase()}`}
                        name="leadStatus"
                        value={enquiryDetails.leadStatus || ""}
                        disabled={!isEditMode}
                        onChange={(e) => {
                          handleChange(e);
                          setIsOpenConverted(true);
                        }}
                        style={
                          enquiryDetails.leadStatus === "open"
                            ? {
                              backgroundColor: "#fbdc6e",
                              color: "rgb(94, 94, 14)",
                            }
                            : {}
                        }
                      >

                        {!["Hold", "No Response", "Converted", "Not Feasible", "Cancelled"].includes(enquiryDetails.leadStatus) && enquiryDetails.leadStatus && (
                          <option value={enquiryDetails.leadStatus} hidden>
                            {enquiryDetails.leadStatus}
                          </option>
                        )}
                        <option  value="">Select Status</option>
                        <option style={{background:"#ffa770"}} value="Hold">Hold</option>
                        <option style={{background:"#ffa5ee"}} value="No Response">No Response</option>
                        <option  style={{background:"#b0e9bd"}} value="Converted">Converted</option>
                        <option  style={{background:"#7ce8f0"}} value="Not Feasible">Not Feasible</option>
                        <option  style={{background:"#f07c7c"}} value="Cancelled">Cancelled</option>
                      </select>

                    ) : (


                      <input
  type="button"
  onClick={() => setIsOpenConverted(true)}
  className={`lead-status-select dropbtn form-input converted-form lead-${enquiryDetails.leadStatus?.replace(/\s/g, '-').toLowerCase()}`}
  style={{
    ...(enquiryDetails.leadStatus?.toLowerCase() === "open" && {
      backgroundColor: "#fbdc6e",
      color: "rgb(94, 94, 14)",
    }),
    ...(enquiryDetails.leadStatus?.toLowerCase() === "converted" && {
      backgroundColor: "#a7f5a7",
      color: "green",
    }),
    ...(enquiryDetails.leadStatus?.toLowerCase() === "no response" && {
      backgroundColor: "#f8c2c2",
      color: "#7a1f1f",
    }),
    ...(enquiryDetails.leadStatus?.toLowerCase() === "hold" && {
      backgroundColor: "#ffd59e",
      color: "#704d00",
    }),
  }}
  value={enquiryDetails.leadStatus || ""}
/>

                      // 👉 Shown when hideButtons === false

                    )} */}


  
        

                      <select
                        className={`lead-status-select dropbtn form-input-select lead-${enquiryDetails.leadStatus?.replace(/\s/g, '-').toLowerCase()}`}
                        name="leadStatus"
                        value={enquiryDetails.leadStatus || ""}
                        disabled={!isEditMode}
                        onChange={(e) => {
                          handleChange(e);
                          setIsOpenConverted(true);
                        }}
                       
                      >

                          {/* <option value={enquiryDetails.leadStatus} hidden>
                            {enquiryDetails.leadStatus}
                          </option> */}
                      
                        <option  value="">Select Status</option>
                        <option style={{background:"#ffa770"}} value="Hold">Hold</option>
                        <option style={{background:"#ffa5ee"}} value="No Response">No Response</option>
                        <option  style={{background:"#b0e9bd"}} value="Converted">Converted</option>
                        <option  style={{background:"#7ce8f0"}} value="Not Feasible">Not Feasible</option>
                        <option  style={{background:"#f07c7c"}} value="Cancelled">Cancelled</option>
                      </select>

                  


                      {/* <input
  type="button"
  onClick={() => setIsOpenConverted(true)}
  className={`lead-status-select dropbtn form-input converted-form lead-${enquiryDetails.leadStatus?.replace(/\s/g, '-').toLowerCase()}`}
  style={{
    ...(enquiryDetails.leadStatus?.toLowerCase() === "open" && {
      backgroundColor: "#fbdc6e",
      color: "rgb(94, 94, 14)",
    }),
    ...(enquiryDetails.leadStatus?.toLowerCase() === "converted" && {
      backgroundColor: "#a7f5a7",
      color: "green",
    }),
    ...(enquiryDetails.leadStatus?.toLowerCase() === "no response" && {
      backgroundColor: "#f8c2c2",
      color: "#7a1f1f",
    }),
    ...(enquiryDetails.leadStatus?.toLowerCase() === "hold" && {
      backgroundColor: "#ffd59e",
      color: "#704d00",
    }),
  }}
  value={enquiryDetails.leadStatus || ""}
/> */}

                    

                  





                    {isOpenConverted && (
                      <div className="overlay1-converted">
                        <div className="modal1-converted">
                          <Container>
                            <button
                              className="close-btn1"
                              onClick={() => setIsOpenConverted(false)}
                            >
                              <span style={{ fontSize: "20px" }}>
                                {" "}
                                &times;{" "}
                              </span>
                            </button>

                            <div
                              // className="open-button border " 
                              className={`open-button1 lead-status-select border lead-${enquiryDetails.leadStatus?.replace(/\s/g, '-').toLowerCase()}`}

                            >
                              <h5>{enquiryDetails.leadStatus}</h5>
                            </div>

                            <textarea
                              style={{
                                textTransform: "capitalize",
                                resize: "none",
                              }}
                              placeholder="Enter Notes"
                              className="converted-textbox"
                              name="enquirynotes"
                              onChange={handleLeadChange}
                              value={
                                enquiryDetails?.enquiryleadStatus?.enquirynotes
                              }
                            />
                            <div className="upload-section">
                              <label className="upload-btn">
                                <FiUpload className="upload-icon" />
                                Upload Image
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                  hidden
                                />
                              </label>
                              {selectedFile && (
                                <p className="file-name">{selectedFile.name}</p>
                              )}
                            </div>

                            <Row>
                              <Col className="date-update-textbox">
                                <label>Next Follow Up Date</label>
                                <br />
                                <input
                                  type="date"
                                  className="field form-input"
                                  value={
                                    enquiryDetails?.enquiryleadStatus?.enquiryLeadStatusnextFollowUpDate
                                  }
                                  onChange={handleLeadChange}
                                  name="enquiryLeadStatusnextFollowUpDate"
                                  min={new Date().toISOString().split("T")[0]} // only allows today or future

                                />
                              </Col>
                              <Col className="uploadbtn-install">
                                <button
                                  type="button"
                                  className="blue-btn"
                                  onClick={() => setIsOpenConverted(false)}
                                >
                                  Upload
                                </button>
                              </Col>
                            </Row>
                          </Container>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </form>



        {/* {showMessageBox && ( */}
      <Row className="container ms-3 me-5">
  <Col md={6} sm={12}>
    <div>
      {Array.isArray(messageData) && messageData.length > 0 ? (
        messageData.map((msg) => (
          <MessageBox key={msg._id} message={msg} />
        ))
      ) : (
        <div className="text-muted">No messages available.</div>
      )}
    </div>
  </Col>

  <Col md={6} sm={12}>
    <div className="compact-updates-history">
      <div className="compact-updates-header">Updates History</div>
      {Array.isArray(messageData) && messageData.length > 0 ? (
        messageData.map((data, index) => (
          <div className="compact-update text-center" key={index}>
            <div className="compact-update-date text-center">
              {data.updatesHistory.date ? (
                new Date(data.updatesHistory.date).toLocaleDateString("en-GB") +
                " - " +
                new Date(data.updatesHistory.date)
                  .toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })
              ) : (
                "No date"
              )}
            </div>

            <div className="compact-update-user text-center">
              {data.updatesHistory?.staff?.name || "Unknown"}
            </div>

            <div
              className="compact-update-status text-center"
              style={{ color: data.colorCode || "#000000" }}
            >
              {data.updatesHistory?.status || "No Status"}
            </div>
          </div>
        ))
      ) : (
        <div className="text-muted text-center">No update history available.</div>
      )}
    </div>
  </Col>
</Row>

        
        {/* )} */}
      </Container>
    </>
  );
}
